import styled, { keyframes } from "styled-components";
import {
  borderRadius,
  borderWidth,
} from "../../../design-system/tokens/borders";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
`;

export const ScrollBody = styled.div<{ $isRefreshing?: boolean }>`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  background: ${({ theme }) => theme.colors.background.secondary};
  padding: ${spacing[3]};
  transition: opacity 0.35s ease;
  opacity: ${({ $isRefreshing }) => ($isRefreshing ? 0.88 : 1)};

  /* Hide scrollbar visually while keeping scroll behaviour */
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;

export const SectionStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
`;

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const FetchingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.surface.overlay};
  z-index: 5;
  pointer-events: none;
`;

export const Spinner = styled.div`
  width: 36px;
  height: 36px;
  border: 3px solid ${({ theme }) => theme.colors.border.subtle};
  border-top-color: ${({ theme }) => theme.colors.interactive.primary};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

export const LoadMoreRow = styled.div`
  display: flex;
  justify-content: center;
  padding: ${spacing[3]};
  border-top: ${borderWidth[1]} solid ${({ theme }) => theme.colors.border.subtle};
`;

export const LoadMoreButton = styled.button`
  ${typographyMixin("body", 3)}
  color: ${({ theme }) => theme.colors.text.interactive};
  background: transparent;
  border: ${borderWidth[1]} solid ${({ theme }) => theme.colors.border.subtle};
  border-radius: ${borderRadius.md};
  padding: ${spacing[2]} ${spacing[4]};
  cursor: pointer;

  &:hover:not(:disabled) {
    background: ${({ theme }) => theme.colors.surface.secondary};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
